import classNames from 'classnames';
import { useState } from 'react';
import { SETTINGS_TAB_NAME } from '../../../common/constants';
import { ImageMetadata } from '../../../common/types/dashboard/DashboardUITypes';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { selectUploadDialogLogoMetadata } from '../../../redux/reducers/uiSlice';
import './Settings.scss';
// import MarketSettings from './market-settings/MarketSettings';
import { getUpdatedCustomFontSize } from '../../../common/util';
import DeleteConfirmDialog from './tab-settings/tab-modal/DeleteConfirmDialog';
import {
  selectSettingsMetadata,
  selectShowTabSettingsModal,
} from '../../../redux/reducers/settingsSlice';
import TabListDialog from './tab-settings/tab-modal/TabListDialog';
import TabMessage from './tab-settings/tab-modal/TabMessageDialog';
import FieldSettings from './field-settings/FieldSettings';
import LoiDateSettings from './date-format-settings/LoiDateSettings';
import AutoFilterViewSettings from './auto-filter-view-settings/AutoFilterViewSettings';
import UserSettings from './user-settings/UserSettings';
import ReminderPeriodSettings from './reminder-period-settings/ReminderPeriodSettings';

function Settings() {
  const logo: ImageMetadata = useAppSelector(selectUploadDialogLogoMetadata);
  const settingsMetadata = useAppSelector(selectSettingsMetadata);
  const sortedSettingsMetadata = [...settingsMetadata]?.sort((a, b) => a.uiOrder - b.uiOrder);

  const dispatch = useAppDispatch();
  const [selectedSettings, setSelectedSettings] = useState(SETTINGS_TAB_NAME.USER);
  const showTabSettingsModal = useAppSelector(selectShowTabSettingsModal);
  const customStyle = {
    fontWeight: 'normal',
    '--custom-settings-font-size': getUpdatedCustomFontSize('--custom-settings-font-size'),
  };

  return (
    <div className='settings-holder' style={customStyle}>
      <div className='flex settings-tab-content-container'>
        <div className='flex settings-tab-container'>
          {sortedSettingsMetadata.filter(e => e.uiOrder > 0).map((value) => {
            return (
              <div
                key={value.name}
                className={classNames(
                  'setting-tab',
                  selectedSettings == value.name
                    ? 'setting-tab-text-selected'
                    : 'setting-tab-text-not-selected',
                )}
                style={{ cursor: 'pointer' }}
                onClick={() => setSelectedSettings(value.name)}>
                <div className='setting-tab-text'>{value.uiText}</div>
                {/* {value.uiText === 'LOI Filter Levels' && (
                  <div className='setting-sub-tabs'>
                    {filterViewData.map((item, index) => (
                      <div 
                        onClick={() => dispatch(setActiveAutoFilterTab(item.externalId))}
                        className={classNames(
                          activeLOIFilterId == item.externalId
                            ? 'setting-sub-tab-text-selected'
                            : 'setting-sub-tab-text-not-selected',
                        )}
                        key={index}>
                        {item.name}
                      </div>
                    ))}
                  </div>
                )} */}
              </div>
            );
          })}
        </div>
        <div className='flex flex-basis settings-content-container'>
          {/* {selectedSettings == SETTINGS_TAB_NAME.GENERAL && (
            <GeneralSettings key={2}></GeneralSettings>
          )} */}
          {selectedSettings == SETTINGS_TAB_NAME.REMINDER && (
            <ReminderPeriodSettings key={2}></ReminderPeriodSettings>
          )}
          {selectedSettings == SETTINGS_TAB_NAME.FieldNames && (
            <FieldSettings key={3}></FieldSettings>
          )}
          {selectedSettings == SETTINGS_TAB_NAME.LoiDateFormat && (
            <LoiDateSettings key={4}></LoiDateSettings>
          )}
          {selectedSettings == SETTINGS_TAB_NAME.AutoFilteredLois && (
            <AutoFilterViewSettings key={5}></AutoFilterViewSettings>
          )}
          {selectedSettings == SETTINGS_TAB_NAME.USER && (
            <UserSettings key={6}></UserSettings>
          )}
          {/* {selectedSettings == SETTINGS_TAB_NAME.TAB && <TabSettings key={3}></TabSettings>} */}
        </div>
      </div>
      <div>
        {showTabSettingsModal === 'deleteTab' && <DeleteConfirmDialog></DeleteConfirmDialog>}
        {showTabSettingsModal === 'moveTabAlias' && <TabListDialog></TabListDialog>}
        {showTabSettingsModal === 'tabMessage' && <TabMessage isActionable={false}></TabMessage>}
        {showTabSettingsModal === 'tabMessageActionable' && (
          <TabMessage isActionable={true}></TabMessage>
        )}
      </div>
    </div>
  );
}

export default Settings;
